<template>
    <div class="content">
        <div class="content-head">
            <div class="content-head-title">搜索</div>
            <el-form :inline="true" class="demo-form-inline">
                <el-form-item label="收货地址">
                    <el-select v-model="params.Orders_Address_Country" placeholder="请选择国家" class="el-select-mini">
                        <el-option v-for="item in countryList" :key="item.Country_Code" :label="item.Country_CN" :value="item.Country_Code"></el-option>
                    </el-select>
                    &nbsp;
                    <el-select v-model="params.Orders_Address_Province" placeholder="请选择省" class="el-select-mini" @change="provinceChange" clearable filterable>
                        <el-option v-for="item in provinceList" :key="item.Code" :label="item.Name" :value="item.Code"></el-option>
                    </el-select>
                    &nbsp;
                    <el-select v-model="params.Orders_Address_City" placeholder="请选择市/地区" class="el-select-mini" @change="cityChange" clearable filterable>
                        <el-option v-for="item in cityListopt" :key="item.Code" :label="item.Name" :value="item.Code"></el-option>
                    </el-select>
                    &nbsp;
                    <el-select v-model="params.Orders_Address_District" placeholder="请选择区/县" class="el-select-mini" clearable filterable>
                        <el-option v-for="item in districtListopt" :key="item.Code" :label="item.Name" :value="item.Code"></el-option>
                    </el-select>
                </el-form-item>

                <el-form-item label="缺货处理">
                    <el-select v-model="params.ShortStock_Status" placeholder="请选择" class="el-select-medium">
                        <el-option v-for="item in ShortStock_Status_opt" :key="item.value" :label="item.label" :value="item.value"></el-option>
                    </el-select>
                </el-form-item>

                <el-form-item label="待补章">
                    <el-select v-model="params.waitsign_status" placeholder="请选择" class="el-select-medium">
                        <el-option v-for="item in waitsign_status_opt" :key="item.value" :label="item.label" :value="item.value"></el-option>
                    </el-select>
                </el-form-item>

                <el-form-item label="付款方式">
                    <el-select v-model="params.paytype" placeholder="请选择" class="el-select-medium">
                        <el-option label="全部合同" :value="0" :title="'全部合同'">
                            <el-tooltip effect="dark" :content="'全部合同'" placement="right">
                                <span class="ellipsis-option">全部合同</span>
                            </el-tooltip>
                        </el-option>
                        <el-option v-for="item in paytype_opt" :key="item.Pay_Type_ID" :label="item.Pay_Type_Name" :value="item.Pay_Type_ID">
                            <el-tooltip effect="dark" :content="item.Pay_Type_Name" placement="right">
                                <span class="ellipsis-option">{{ item.Pay_Type_Name }}</span>
                            </el-tooltip>
                        </el-option>
                    </el-select>
                </el-form-item>

                <el-form-item label="折扣分组" v-if="isFiltration">
                    <el-select v-model="params.Orders_DiscountCate" placeholder="请选择" class="el-select-medium">
                        <el-option v-for="item in Orders_DiscountCate_List" :key="item.Code" :label="item.Name" :value="item.Code"></el-option>
                    </el-select>
                </el-form-item>

                <el-form-item label="订单类型" v-if="isFiltration">
                    <el-select v-model="params.Orders_Type" placeholder="请选择" class="el-select-medium">
                        <el-option label="全部类型" value=""></el-option>
                        <el-option v-for="item in Orders_Type_List" :key="item.Code" :label="item.Name" :value="item.Code"></el-option>
                    </el-select>
                </el-form-item>

                <el-form-item label="订单日期" v-if="isFiltration">
                    <el-date-picker v-model="params.date_start" type="date" placeholder="开始日期" value-format="yyyy-MM-dd" clearable></el-date-picker>
                    <span style="margin: 0 5px">至</span>
                    <el-date-picker v-model="params.date_end" type="date" placeholder="结束日期" value-format="yyyy-MM-dd" clearable></el-date-picker>
                </el-form-item>

                <el-form-item label="电子签章状态" v-if="isFiltration">
                    <el-select v-model="params.Orders_ESignStatus" placeholder="请选择" class="el-select-medium">
                        <el-option v-for="item in Orders_ESignStatus_List" :key="item.value" :label="item.name" :value="item.value"></el-option>
                    </el-select>
                </el-form-item>

                <el-form-item label="合同纸状态" v-if="isFiltration">
                    <el-select v-model="params.RecoverStatus" placeholder="请选择" class="el-select-medium">
                        <el-option v-for="item in RecoverStatus_opt" :key="item.value" :label="item.label" :value="item.value"></el-option>
                    </el-select>
                </el-form-item>

                <el-form-item label="ERP订单号" v-if="isFiltration">
                    <el-input v-model="params.erpsn" placeholder="请输入" clearable class="el-select-medium"></el-input>
                </el-form-item>
                <el-form-item label="订单号" v-if="isFiltration">
                    <el-input v-model="params.keyword" placeholder="请输入" clearable class="el-select-medium"></el-input>
                </el-form-item>

                <el-form-item label="客户名称" v-if="isFiltration">
                    <el-input v-model="params.customername" placeholder="请输入" clearable class="el-select-medium"></el-input>
                </el-form-item>
                <el-form-item label="工程名称" v-if="isFiltration">
                    <el-input v-model="params.projectname" placeholder="请输入" clearable class="el-select-medium"></el-input>
                </el-form-item>
                <el-form-item label="业务员" v-if="isFiltration">
                    <el-input v-model="params.officeman" placeholder="请输入" clearable class="el-select-medium"></el-input>
                </el-form-item>
                <el-form-item label="收货人" v-if="isFiltration">
                    <el-input v-model="params.addressname" placeholder="请输入" clearable class="el-select-medium"></el-input>
                </el-form-item>

                <el-form-item label="商品名称" v-if="isFiltration">
                    <el-input v-model="params.product_name" placeholder="请输入" clearable class="el-select-medium"></el-input>
                </el-form-item>

                <el-form-item>
                    <el-button type="primary" @click="getOrders(true)" icon="el-icon-search" :loading="loadingBtn">搜索</el-button>
                </el-form-item>
                <el-form-item>
                    <el-button @click="onRefresh" icon="el-icon-refresh">重置</el-button>
                </el-form-item>
                <el-form-item>
                    <el-button @click="setFiltration" :icon="!isFiltration ? 'el-icon-arrow-down' : 'el-icon-arrow-up'">
                        {{ !isFiltration ? '展开' : '收起' }}
                    </el-button>
                </el-form-item>
            </el-form>
            <el-form :inline="true" class="demo-form-inline">
                <el-form-item label="下单时间">
                    <el-select v-model="params.addtime" placeholder="请选择" class="el-select-medium">
                        <el-option label="全部" :value="0"></el-option>
                        <el-option label="7天以内" :value="7"></el-option>
                        <el-option label="15天以内" :value="15"></el-option>
                        <el-option label="30天以内" :value="30"></el-option>
                    </el-select>
                    <!-- <el-radio-group v-model="params.addtime" @input="getOrders">
                        <el-radio :label="0">全部</el-radio>
                        <el-radio :label="7">7天以内</el-radio>
                        <el-radio :label="15">15天以内</el-radio>
                        <el-radio :label="30">30天以内</el-radio>
                    </el-radio-group> -->
                </el-form-item>
                <el-form-item label="订单状态">
                    <el-select v-model="params.orders_status" placeholder="请选择" class="el-select-medium">
                        <el-option label="全部" :value="-1"></el-option>
                        <el-option label="正常" :value="1"></el-option>
                        <el-option label="交易成功" :value="2"></el-option>
                        <el-option label="已取消" :value="3"></el-option>
                    </el-select>

                    <!-- <el-radio-group v-model="params.orders_status" @input="getOrders">
                        <el-radio-button :label="-1">全部</el-radio-button>
                        <el-radio-button :label="1">正常</el-radio-button>
                        <el-radio-button :label="2">交易成功</el-radio-button>
                        <el-radio-button :label="3">已取消</el-radio-button>
                    </el-radio-group> -->
                </el-form-item>

                <el-form-item label="审核状态">
                    <el-select v-model="params.orders_auditstatus" placeholder="请选择" class="el-select-medium">
                        <el-option label="全部" :value="-1"></el-option>
                        <el-option label="待审核" :value="1"></el-option>
                        <el-option label="已下达" :value="2"></el-option>
                        <el-option label="审核失败" :value="3"></el-option>
                    </el-select>
                    <!-- <el-radio-group v-model="params.orders_auditstatus" @input="getOrders">
                        <el-radio-button :label="-1">全部</el-radio-button>
                        <el-radio-button :label="1">待审核</el-radio-button>
                        <el-radio-button :label="2">已下达</el-radio-button>
                        <el-radio-button :label="3">审核失败</el-radio-button>
                    </el-radio-group> -->
                </el-form-item>

                <el-form-item label="支付状态">
                    <el-select v-model="params.orders_auditstatus" placeholder="请选择" class="el-select-medium">
                        <el-option label="全部" :value="-1"></el-option>
                        <el-option label="未支付" :value="0"></el-option>
                        <el-option label="已支付" :value="1"></el-option>
                        <el-option label="已到账" :value="4"></el-option>
                        <el-option label="已审核超额度" :value="5"></el-option>
                        <el-option label="零预付" :value="6"></el-option>
                    </el-select>
                    <!-- <el-radio-group v-model="params.orders_paymentstatus" @input="getOrders">
                        <el-radio-button :label="-1">全部</el-radio-button>
                        <el-radio-button :label="0">未支付</el-radio-button>
                        <el-radio-button :label="1">已支付</el-radio-button>
                        <el-radio-button :label="4">已到账</el-radio-button>
                        <el-radio-button :label="5">已审核超额度</el-radio-button>
                        <el-radio-button :label="6">零预付</el-radio-button>
                    </el-radio-group> -->
                </el-form-item>

                <el-form-item label="发货状态">
                    <el-select v-model="params.orders_auditstatus" placeholder="请选择" class="el-select-medium">
                        <el-option label="全部" :value="-1"></el-option>
                        <el-option label="未发货" :value="0"></el-option>
                        <el-option label="部分发货" :value="4"></el-option>
                        <el-option label="已发货" :value="1"></el-option>
                    </el-select>

                    <!-- <el-radio-group v-model="params.orders_deliverystatus" @input="getOrders">
                        <el-radio-button :label="-1">全部</el-radio-button>
                        <el-radio-button :label="0">未发货</el-radio-button>
                        <el-radio-button :label="4">部分发货</el-radio-button>
                        <el-radio-button :label="1">已发货</el-radio-button>
                    </el-radio-group> -->
                </el-form-item>
            </el-form>
        </div>
        <div class="content-table">
            <div class="content-table-title">
                订单列表
                <span>
                    <el-dropdown trigger="click" style="margin-left: 10px; margin-right: 10px">
                        <el-button>
                            导出
                            <i class="el-icon-arrow-down el-icon--right"></i>
                        </el-button>
                        <el-dropdown-menu slot="dropdown">
                            <el-dropdown-item>
                                <span @click="getPipelineApplysExport(1)">导出商品清单</span>
                            </el-dropdown-item>
                            <el-dropdown-item>
                                <span @click="getPipelineApplysExport(2)">导出全部商品清单</span>
                            </el-dropdown-item>
                            <el-dropdown-item>
                                <span @click="getPipelineApplysExport(3)">导出订单信息</span>
                            </el-dropdown-item>
                            <el-dropdown-item>
                                <span @click="getPipelineApplysExport(4)">导出全部订单信息</span>
                            </el-dropdown-item>
                        </el-dropdown-menu>
                    </el-dropdown>
                </span>
            </div>
            <el-table :data="tableData" @selection-change="handleSelectionChange" :height="maxheight" ref="multipleTable" border style="width: 100%" :header-cell-style="{ backgroundColor: '#F5F7FA' }" v-loading="loadingBtn">
                <el-table-column type="selection" width="55" fixed align="center"></el-table-column>
                <el-table-column prop="Orders_ID" label="ID" width="80" align="center" fixed></el-table-column>
                <el-table-column prop="Orders_OfficeManName" label="业务员" width="120" align="center" show-overflow-tooltip></el-table-column>
                <el-table-column prop="Orders_Addtime" show-overflow-tooltip width="150" label="下单时间" align="center">
                    <template slot-scope="scope">
                        <span>{{ scope.row.Orders_Addtime | formatDate }}</span>
                    </template>
                </el-table-column>
                <el-table-column prop="Orders_SN" label="订单号" align="center" width="150"></el-table-column>
                <el-table-column prop="Orders_ERPSN" label="ERP订单号" align="center" width="150"></el-table-column>
                <el-table-column prop="Orders_CustomerName" show-overflow-tooltip width="150" label="客户名称" align="center"></el-table-column>
                <el-table-column prop="Orders_ProjectName" show-overflow-tooltip label="工程名称" align="center" width="150"></el-table-column>
                <el-table-column prop="Orders_Total_AllPrice" width="200" label="订单总额" align="center">
                    <template slot-scope="scope">
                        <span>￥{{ scope.row.Orders_Total_AllPrice }}</span>
                    </template>
                </el-table-column>
                <el-table-column prop="StateName" label="订单状态" width="150" align="center">
                    <template slot-scope="scope">
                        <span :class="scope.row.StateName == '已取消' ? 'is-status-text' : 'sucess-status-text'">{{ scope.row.StateName }}</span>
                    </template>
                </el-table-column>
                <el-table-column prop="AuditStateName" width="150" label="订单审核状态" align="center">
                    <template slot-scope="scope">
                        <span :class="judgeColor(scope.row.AuditStateName)">{{ scope.row.AuditStateName }}</span>
                    </template>
                </el-table-column>
                <el-table-column prop="BPMStateName" width="150" label="BPM审核状态" align="center">
                    <template slot-scope="scope">
                        <span :class="judgeColor(scope.row.BPMStateName)">{{ scope.row.BPMStateName }}</span>
                    </template>
                </el-table-column>

                <el-table-column prop="Orders_AttachmentAudit" width="150" label="合同审核状态" align="center">
                    <template slot-scope="scope">
                        <span :class="judgeColor(scope.row.Orders_AttachmentAudit)">{{ scope.row.Orders_AttachmentAudit }}</span>
                    </template>
                </el-table-column>
                <el-table-column prop="Orders_PaymentStatus" width="150" label="付款状态" align="center">
                    <template slot-scope="scope">
                        <span :class="judgeColor(scope.row.Orders_PaymentStatus)">{{ scope.row.Orders_PaymentStatus }}</span>
                    </template>
                </el-table-column>
                <el-table-column prop="RMAName" width="150" label="发货状态" align="center">
                    <template slot-scope="scope">
                        <span :class="judgeColor(scope.row.Orders_DeliveryStatus)">{{ scope.row.Orders_DeliveryStatus }}</span>
                    </template>
                </el-table-column>

                <el-table-column prop="RecoverStatusName" width="250" label="合同纸状态" align="center">
                    <template slot-scope="scope">
                        <span :class="judgeColor(scope.row.Orders_RecoverStatus)">{{ scope.row.Orders_RecoverStatus }}</span>
                    </template>
                </el-table-column>
                <el-table-column prop="Orders_SourceType" width="150" label="来源" align="center"></el-table-column>
                <el-table-column label="操作" align="center" width="200" fixed="right">
                    <template slot-scope="scope">
                        <div class="operation-bar">
                            <span class="operation-bar-block" @click="handleViewsDetail(scope.row)">查看</span>
                            <span class="operation-bar-block" v-if="scope.row.SPCCopyState == 'true'" @click="SPCApplyToSPCOrdersCheck(scope.row)">复制</span>
                            <span class="operation-bar-block" v-if="scope.row.InvoiceState == 'true'" @click="Office_CheckInvoiceApply(scope.row)">全额开具发票</span>
                        </div>
                    </template>
                </el-table-column>
            </el-table>
            <div>
                <Pagination :paginationOptions="paginationOptions" @size-change="handleSizeChange" @current-change="handleCurrentChange" />
            </div>
        </div>
        <!-- <orderDetails :isDetails="isDetails" :id="id" @handleClose="handleClose"></orderDetails> -->
    </div>
</template>

<script>
import Pagination from '@/components/Pagination.vue';
import { formatDate, downloadFile } from '@/utils/utils.js';
import { myMixin } from '@/utils/mixin.js';
import { mapState } from 'vuex';
import orderDetails from '@/views/orderManagement/components/orderDetails.vue';
export default {
    name: 'performanceorderList',
    mixins: [myMixin],
    components: {
        Pagination
        // orderDetails
    },
    computed: {
        ...mapState({
            countryList: (state) => state.common.countryList,
            provinceList: (state) => state.common.provinceList,
            cityList: (state) => state.common.cityList,
            districtList: (state) => state.common.districtList
        })
    },
    data() {
        return {
            id: 0,
            isDetails: false,
            loadingBtn: false,
            params: {
                Orders_Address_Country: '', //国家
                Orders_Address_District: '', //省
                Orders_Address_City: '', //市
                Orders_Address_Province: '', //县区
                ShortStock_Status: 0, //缺货处理
                waitsign_status: 0, //候补zhang
                date_start: '', //订单日期
                date_end: '', //订单日期
                orders_tradetype: '',
                paytype: 0, //付款方式
                RecoverStatus: 0, //合同纸状态
                orders_bpmauditstatus: '',
                Orders_ESignStatus: 0, //电子签章状态
                Orders_DiscountCate: '', //折扣分组
                orders_type: '', //订单类型
                officeman: '', //业务员
                keyword: '',
                erpsn: '',
                projectname: '', //工程名称
                customername: '', //客户名称
                product_name: '', //商品名称
                addressname: '', //收货人
                Orders_SourceERPSN: '',
                addtime: 0,
                orders_auditstatus: -1,
                orders_paymentaudit: -6,
                orders_status: -1,
                orders_paymentstatus: -1,
                orders_deliverystatus: -1
                // orders_sourcetype: 0 //全部订单 1商城订单
            },
            tableData: [],
            cityListopt: [],
            districtListopt: [],
            ShortStock_Status_opt: [
                { label: '全部订单', value: 0 },
                { label: '未处理订单', value: 1 },
                { label: '已处理订单', value: 2 }
            ],
            waitsign_status_opt: [
                { label: '全部订单', value: 0 },
                { label: '非待补章', value: 1 },
                { label: '待补章', value: 2 }
            ],
            RecoverStatus_opt: [
                { label: '全部订单', value: 0 },
                { label: '不需要回收订单', value: 1 },
                { label: '待回收订单', value: 2 },
                { label: '已回收订单', value: 3 }
            ],
            paytype_opt: [],
            Orders_ESignStatus_List: [
                { name: '全部', value: 0 },
                { name: '不需要', value: 1 },
                { name: '电子签章订单', value: -1 },
                { name: '待同步', value: 2 },
                { name: '发送失败', value: 3 },
                { name: '海湾签章失败', value: 4 },
                { name: '待客户签署', value: 5 },
                { name: '客户签署完成', value: 6 },
                { name: '客户拒签', value: 7 },
                { name: '逾期未签署', value: 8 },
                { name: '客户签署失败', value: 9 },
                { name: '已撤回', value: 10 }
            ],
            Orders_DiscountCate_List: [],
            Orders_Type_List: [], //订单类型
            multipleSelection: [] //多选
        };
    },
    mounted() {
        this.$store.dispatch('fetchLocationData');
        this.getOrdersPayTypes();
        this.onRefresh();
    },
    methods: {
        //重置
        onRefresh() {
            this.params = {
                Orders_Address_Country: '', //国家
                Orders_Address_District: '', //省
                Orders_Address_City: '', //市
                Orders_Address_Province: '', //县区
                ShortStock_Status: 0, //缺货处理
                waitsign_status: 0, //候补zhang
                date_start: '', //订单日期
                date_end: '', //订单日期
                orders_tradetype: '',
                paytype: 0, //付款方式
                RecoverStatus: 0, //合同纸状态
                orders_bpmauditstatus: '',
                Orders_ESignStatus: 0, //电子签章状态
                Orders_DiscountCate: '', //折扣分组
                orders_type: '', //订单类型
                officeman: '', //业务员
                keyword: '',
                erpsn: '',
                projectname: '', //工程名称
                customername: '', //客户名称
                product_name: '', //商品名称
                addressname: '', //收货人
                Orders_SourceERPSN: '',
                addtime: 0,
                orders_auditstatus: -1,
                orders_status: -1,
                orders_paymentstatus: -1,
                orders_deliverystatus: -1,
                orders_paymentaudit: -6
                // orders_sourcetype: 0 //全部订单 1商城订单
            };
            this.getOrders(true);
        },
        handleSizeChange(newSize) {
            this.paginationOptions.PageSize = newSize;
            this.getOrders();
        },
        handleCurrentChange(newPage) {
            this.paginationOptions.Page = newPage;
            this.getOrders();
        },
        addtimestatusChange() {
            console.log(123);
        },
        //申请单管理列表
        getOrders(flag = false) {
            this.loadingBtn = true;
            if (flag) {
                this.paginationOptions = {
                    Page: 1,
                    total: 0,
                    PageSize: 40
                };
            }
            this.$newsApi.order
                .getOrders(this.filteropt())
                .then((res) => {
                    if (res.data.Resultcode == 0) {
                        this.tableData = res.data.data;
                        this.paginationOptions.total = res.data.RecordCount;
                    }
                })
                .finally(() => (this.loadingBtn = false));
        },
        filteropt() {
            let params = { ...this.params, orders_paymentaudit: '-6' };
            return { json: JSON.stringify(params), Page: this.paginationOptions.Page, PageSize: this.paginationOptions.PageSize };
        },
        //导出所有
        getPipelineApplysExport(e) {
            let json = [];
            json = this.multipleSelection
                .map((item) => {
                    return item.Orders_ID;
                })
                .join();
            // let needObj = JSON.stringify({

            // });
            let loadingInstance = this.$loading(); // 显示 loading
            switch (e) {
                case 1: //导出商品清单
                    this.$newsApi.Orders_Goods_Export({ json: json }).then((res) => {
                        this.$closeLoading(loadingInstance); // 关闭 loading
                        if (res.data.Resultcode == 0) {
                            downloadFile(res.data.data, res.data.Resultinfo);
                        }
                    });
                    break;
                case 2: //导出全部商品清单
                    this.$newsApi.Orders_Goods_Export_All(this.filteropt()).then((res) => {
                        this.$closeLoading(loadingInstance); // 关闭 loading
                        if (res.data.Resultcode == 0) {
                            downloadFile(res.data.data, res.data.Resultinfo);
                        }
                    });
                    break;
                case 3: //导出订单信息
                    this.$newsApi.Orders_Export({ json: json }).then((res) => {
                        this.$closeLoading(loadingInstance); // 关闭 loading
                        if (res.data.Resultcode == 0) {
                            downloadFile(res.data.data, res.data.Resultinfo);
                        }
                    });
                    break;
                case 4: //导出全部订单信息
                    this.$newsApi.Orders_Export_All(this.filteropt()).then((res) => {
                        this.$closeLoading(loadingInstance); // 关闭 loading
                        if (res.data.Resultcode == 0) {
                            downloadFile(res.data.data, res.data.Resultinfo);
                        }
                    });
                    break;
            }
        },
        handleViewsDetail(row) {
            this.$store.commit('SET_TAGTITLE', '订单详情');
            this.$router.push(`/orderManagement/orderDetails?id=${row.Orders_ID}`);
            this.id = row.Orders_ID;
            // this.id = row.Orders_ID;
            return;
            // this.isDetails = true;
            // console.log(this.isDetails, row, 'isdetails');
        },
        // handleClose() {
        //     this.isDetails = false;
        // },
        /*
        获取付款方式
        */
        getOrdersPayTypes() {
            const TradeType = 2;
            const Customer_Type = 0;
            const Customer_IsLimitPay = 0;
            this.$newsApi.order.GetAllPayTypes().then((res) => {
                if (res.data.Resultcode == 0) {
                    this.paytype_opt = res.data.data;
                }
            });
            this.GetAllDiscountCategory();
            this.OrdersDiscountCates();
        },
        /*
        选择省
        */
        provinceChange(e) {
            console.log(e, 'eeeee');
            this.cityListopt = [];
            this.params.Orders_Address_City = '';
            this.districtListopt = [];
            this.params.Orders_Address_District = '';
            this.cityListopt = this.cityList.filter((item) => item.Statecode == e);
        },
        /*
        选择市
        */
        cityChange(e) {
            console.log(e, 'eeeee');
            this.districtListopt = [];
            this.params.Orders_Address_District = '';
            this.districtListopt = this.districtList.filter((item) => item.citycode == e);
            console.log(this.districtListopt, 'this.districtListoptthis.districtListopt');
        },
        /*
        多选
        */
        handleSelectionChange(val) {
            this.multipleSelection = val;
        },
        // 获取销售类型
        GetAllDiscountCategory() {
            this.$newsApi.getDiscountCategorys().then((res) => {
                if (res.data.Resultcode == 0) {
                    this.Orders_DiscountCate_List = res.data.data;
                }
            });
        },
        // 获取订单类型
        OrdersDiscountCates() {
            this.$newsApi.OrdersDiscountCates().then((res) => {
                if (res.data.Resultcode == 0) {
                    this.Orders_Type_List = res.data.data;
                }
            });
        },
        // 复制
        SPCApplyToSPCOrdersCheck(row) {
            // 修改合同
            this.$confirm(`确定要复制该订单吗？`, '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            })
                .then(() => {
                    this.$router.push({ path: '/customOrder', query: { CopyId: row.Orders_SPCOrdersID, submitChangeOrderTypes: 1 } });
                })
                .catch(() => {
                    this.$message({
                        type: 'info',
                        message: '已取消'
                    });
                });
        },
        // 全额开具发票
        async Office_CheckInvoiceApply(row) {
            let loadingInstance = this.$loading(); // 显示 loading
            let res = await this.$newsApi.order.Office_CheckInvoiceApply({ OrdersID: row.Orders_ID });
            this.$closeLoading(loadingInstance); // 关闭 loading
            if (res.data.Resultcode == 0) {
                this.$router.push({ path: '/orderManagement/invoiceIssuance', query: { OrdersID: row.Orders_ID } });
            }
        }
    }
};
</script>
